<div class="container">
  <ng-container *ngIf="store$ | async as store">
    <div
      gdAreas="photo info | details details"
      gdAreas.lt-md="photo | info | details"
      gdColumns="1fr 3fr"
      gdColumns.sm="repeat(auto-fill, minmax(400px, 2fr))"
      gdColumns.xs="repeat(auto-fill, minmax(300px, 1fr))"
      gdGap="16px"
      gdRows="auto auto"
      gdRows.lt-md="auto auto auto"
    >
      <div gdArea="photo">
        <app-store-image [store]="store" [maxWidth]="'200px'"></app-store-image>
      </div>
      <div gdArea="info">
        <div fxLayout="row">
          <h1>
            <b>
              {{ store.name }}
            </b>
          </h1>
        </div>
        <p>
          {{ store.description }}
        </p>
      </div>
      <div gdArea="details">
        <div class="container">
          <h2 id="productList"><b>Tous les produits</b></h2>

          <ng-container *ngIf="storeProducts$ | async as storeProducts">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="start center"
              fxLayoutGap="16px grid"
            >
              <div
                *ngFor="
                  let product of storeProducts
                    | paginate
                      : {
                          id: 'store',
                          itemsPerPage: productsPerPage,
                          currentPage: page,
                          totalItems: totalProducts
                        };
                  trackBy: productService.trackByProductID
                "
                fxFlex="25"
                fxFlex.lt-md="50"
              >
                <app-product-card [product]="product"></app-product-card>
              </div>
            </div>
            <br />
            <div fxLayout="row" fxLayoutAlign="center center">
              <app-custom-pagination-controls
                (pageChange)="getProductsForPage($event)"
                [autoHide]="true"
                [id]="'store'"
                [nextLabel]="'Page Suivante'"
                [previousLabel]="'Page Précédente'"
                [responsive]="true"
                class="my-pagination"
              >
              </app-custom-pagination-controls>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <br />
  </ng-container>
</div>
